import * as allIcons from './index';

export const WALLET_ICONS = {
  alien: allIcons.AlienIcon,
  angry: allIcons.AngryIcon,
  apple: allIcons.AppleIcon,
  banana: allIcons.BananaIcon,
  bank: allIcons.BankIcon,
  bike: allIcons.BikeIcon,
  birdhouse: allIcons.BirdhouseIcon,
  bishop: allIcons.BishopIcon,
  bitcoin: allIcons.BitcoinIcon,
  bolt: allIcons.BoltIcon,
  bone: allIcons.BoneIcon,
  boombox: allIcons.BoomboxIcon,
  bot: allIcons.BotIcon,
  bottle: allIcons.BottleIcon,
  bow: allIcons.BowIcon,
  brain: allIcons.BrainIcon,
  briefcase: allIcons.BriefcaseIcon,
  burger: allIcons.BurgerIcon,
  cactus: allIcons.CactusIcon,
  car: allIcons.CarIcon,
  cash: allIcons.CashIcon,
  cat: allIcons.CatIcon,
  cherry: allIcons.CherryIcon,
  citrus: allIcons.CitrusIcon,
  clover: allIcons.CloverIcon,
  coffee: allIcons.CoffeeIcon,
  compass: allIcons.CompassIcon,
  confused: allIcons.ConfusedIcon,
  cookie: allIcons.CookieIcon,
  cow: allIcons.CowIcon,
  cowboy: allIcons.CowboyIcon,
  crow: allIcons.CrowIcon,
  crown: allIcons.CrownIcon,
  deviceLedger: allIcons.DeviceLedgerIcon,
  deviceTrezor: allIcons.DeviceTrezorIcon,
  deviceYubikey: allIcons.DeviceYubikeyIcon,
  dice: allIcons.DiceIcon,
  dog: allIcons.DogIcon,
  dove: allIcons.DoveIcon,
  dumpsterFire: allIcons.DumpsterFireIcon,
  earth: allIcons.EarthIcon,
  egg: allIcons.EggIcon,
  ethereum: allIcons.EthereumIcon,
  eye: allIcons.EyeIcon,
  feather: allIcons.FeatherIcon,
  fish: allIcons.FishIcon,
  fishbone: allIcons.FishboneIcon,
  flame: allIcons.FlameIcon,
  flower: allIcons.FlowerIcon,
  footprint: allIcons.FootprintIcon,
  frog: allIcons.FrogIcon,
  gem: allIcons.GemIcon,
  ghost: allIcons.GhostIcon,
  gingerbread: allIcons.GingerbreadIcon,
  hamsa: allIcons.HamsaIcon,
  happy: allIcons.HappyIcon,
  helicopter: allIcons.HelicopterIcon,
  helmet: allIcons.HelmetIcon,
  hippo: allIcons.HippoIcon,
  house: allIcons.HouseIcon,
  icecream: allIcons.IcecreamIcon,
  incognito: allIcons.IncognitoIcon,
  infinex: allIcons.InfinexIcon,
  jetpack: allIcons.JetpackIcon,
  key: allIcons.KeyIcon,
  keys: allIcons.KeysIcon,
  kiki: allIcons.KikiIcon,
  king: allIcons.KingIcon,
  knight: allIcons.KnightIcon,
  leaf: allIcons.LeafIcon,
  ledger: allIcons.LedgerIcon,
  locust: allIcons.LocustIcon,
  manic: allIcons.ManicIcon,
  meeple: allIcons.MeepleIcon,
  metamask: allIcons.MetamaskIcon,
  meteor: allIcons.MeteorIcon,
  neutral: allIcons.NeutralIcon,
  otter: allIcons.OtterIcon,
  parachute: allIcons.ParachuteIcon,
  paw: allIcons.PawIcon,
  pawn: allIcons.PawnIcon,
  pepper: allIcons.PepperIcon,
  phantom: allIcons.PhantomIcon,
  piggyBank: allIcons.PiggyBankIcon,
  plane: allIcons.PlaneIcon,
  plant: allIcons.PlantIcon,
  puzzle: allIcons.PuzzleIcon,
  queen: allIcons.QueenIcon,
  rabby: allIcons.RabbyIcon,
  rocket: allIcons.RocketIcon,
  rook: allIcons.RookIcon,
  safe: allIcons.SafeIcon,
  shield: allIcons.ShieldIcon,
  shrimp: allIcons.ShrimpIcon,
  skull: allIcons.SkullIcon,
  snake: allIcons.SnakeIcon,
  snowflake: allIcons.SnowflakeIcon,
  solana: allIcons.SolanaIcon,
  spider: allIcons.SpiderIcon,
  star: allIcons.StarIcon,
  steak: allIcons.SteakIcon,
  sun: allIcons.SunIcon,
  testTube: allIcons.TestTubeIcon,
  trash: allIcons.TrashIcon,
  tree: allIcons.TreeIcon,
  trezor: allIcons.TrezorIcon,
  volcano: allIcons.VolcanoIcon,
  wallet: allIcons.WalletIcon,
  wilted: allIcons.WiltedIcon,
  wizard: allIcons.WizardIcon,
  worm: allIcons.WormIcon,
  wyrm: allIcons.WyrmIcon,
};
